"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparisonRule = exports.ComparisonRuleComparisonNames = exports.ComparisonRuleComparisonTypes = exports.ComparisonRuleValueNames = exports.ComparisonRuleValueTypes = exports.ComparisonRuleClassName = void 0;
const ModelCommon_1 = require("./ModelCommon");
exports.ComparisonRuleClassName = 'ComparisonRule';
exports.ComparisonRuleValueTypes = {
    Latest: 'latest',
    Averaged: 'averaged',
    Summed: 'bucketed',
};
exports.ComparisonRuleValueNames = {
    latest: 'Latest',
    averaged: 'Averaged',
    bucketed: 'Summed',
};
exports.ComparisonRuleComparisonTypes = {
    'More Than': 'more',
    'Equal To': 'equal',
    'Different From': 'different',
    'Less Than': 'less',
};
exports.ComparisonRuleComparisonNames = {
    more: 'More Than',
    equal: 'Equal To',
    different: 'Different From',
    less: 'Less Than',
};
class ComparisonRule extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.ComparisonRuleClassName)
            throw new Error(`Tried to create a ${exports.ComparisonRuleClassName} from a ${ob.type} object!`);
        super(exports.ComparisonRuleClassName, ob);
        this.type = ob.type ?? exports.ComparisonRuleClassName;
        this.name = ob.name ?? '';
        this.enabled = ob.enabled ?? false;
        this.key = ob.key ?? '';
        this.valueType = ob.valueType ?? 'latest';
        this.comparisonType = ob.comparisonType ?? 'equal';
        this.triggeringKey = ob.triggeringKey ?? '';
    }
    getUserAttributes() {
        return {
            name: { type: 'String' },
            description: { type: 'String' },
            enabled: { type: 'Boolean', default: false },
            key: { type: 'String', label: 'Reading' },
            valueType: { type: 'Enum', default: exports.ComparisonRuleValueTypes.Latest, enumKv: exports.ComparisonRuleValueTypes },
            comparisonType: { type: 'Enum', default: exports.ComparisonRuleValueTypes.Latest, enumKv: exports.ComparisonRuleValueTypes },
            triggeringKey: { type: 'String', label: 'Attribute' },
        };
    }
}
exports.ComparisonRule = ComparisonRule;
